import React from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  selectedUserState,
  showModalState,
  doctorsDataState,
  doctorIdState,
  appointmentDateState,
  appointmentTypeState,
  appointmentStatusState,
  remarkUpdateState,
  feedbackState,
  ratingState,
  currentPageState,
  filterChangeForUserState,
  filterSelectedForUserState,
  statusFilterState,
  filterSelectedForStatusState,
  mobileNumberState,
  isVideoConsultationAllowedState,
} from "store/appointment/atoms/appointmentAtomState";
import { toast } from "react-toastify";
import dayjs from "dayjs";

import { getToken } from "utils/getToken";
import { parseISO, format } from "date-fns";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import axios from "axios";
import { useEffect, useState } from "react";
import {
  ghostBtn,
  input as inputCls,
  microLabel,
  primaryBtn,
  select as selectCls,
} from "components/ui/instrument";

const appointmentStatusSelectOptions = [
  { name: "Created", value: "created" },
  { name: "Scheduled", value: "scheduled" },
  { name: "Pending Confirmation", value: "pending_confirmation" },
  { name: "On Going", value: "on_going" },
  { name: "Consultation Done", value: "consultation_done" },
  { name: "Cancelled", value: "cancelled" },
  { name: "Closed", value: "closed" },
];

interface AppointmentModalProps {
  handleCloseModal: () => void;
  fetchData: (params: any) => void;
}

const AppointmentModal = ({
  handleCloseModal,
  fetchData,
}: AppointmentModalProps) => {
  const selectedUser = useRecoilValue(selectedUserState);
  const [showModal, setShowModal] = useRecoilState(showModalState);
  const doctors_Data = useRecoilValue(doctorsDataState);

  const [doctorsData, setDoctorsData] = useState<any[]>(doctors_Data);
  
  const [doctorId, setDoctorId] = useRecoilState(doctorIdState);
  const [dateIsNull,setDateIsNull]=useState(selectedUser.scheduled_at===null);
  const [appointmentDate, setAppointmentDate] =
    useRecoilState(appointmentDateState);
  const [slotId, setSlotId] = useState("");
  const [slots, setSlots] = useState<any[]>([]);
  const appointmentType = useRecoilValue(appointmentTypeState);
  const [appointmentStatus, setAppointmentStatus] = useRecoilState(
    appointmentStatusState
  );
  const mobileNumber = useRecoilValue(mobileNumberState);

  const [feedback, setFeedback] = useRecoilState(feedbackState);
  const [rating, setRating] = useRecoilState(ratingState);
  const [remarkUpdate, setRemarkUpdate] = useRecoilState(remarkUpdateState);
  const filterChangeForUser = useRecoilValue(filterChangeForUserState);
  const statusFilter = useRecoilValue(statusFilterState);
  const isFilterSelectedForUser = useRecoilValue(filterSelectedForUserState);
  const isFilterSelectedForStatus = useRecoilValue(
    filterSelectedForStatusState
  );

  const currentPage = useRecoilValue(currentPageState);
  const [isVideoConsultationAllowed, setIsVideoConsultationAllowed] =
    useRecoilState(isVideoConsultationAllowedState);

  const handleAppointmentStatusChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { value } = e.target;
    setAppointmentStatus(value);
  };

  const handleSaveClick = async () => {
    if (
      selectedUser.appointment_type === "growth" ||
      selectedUser.appointment_type.toLowerCase().includes("lactation")
    ) {
      if (doctorId === "0") {
        toast.error("Please select a doctor");
        return;
      }
      // if (slotId === "0" || slotId === "" || slotId === null) {
      //   console.log("called slotId");
      //   toast.error("Please select a slot");
      //   return;
      // }
    }

    const slot_id = parseInt(slotId);
    const updatedUser = {
      ...selectedUser,
      appointment_type: appointmentType,
      slot_id: slot_id,
      appointment_status: appointmentStatus,
    };


    if (
      selectedUser.appointment_type === "growth" ||
      selectedUser.appointment_type.toLowerCase().includes("lactation")
    ) {
      updatedUser.scheduled_at = appointmentDate;
    }

    if (updatedUser.appointment_status === "scheduled") {
      if (!selectedUser.patient_id || selectedUser.patient_id === "") {
        toast.error(
          "Please select a patient before scheduling the appointment"
        );
        setShowModal(false);
        return;
      }
    }

    try {
      const remarkUpdateData = remarkUpdate
        ? {
            email_id: localStorage.getItem("loginEmail"),
            time: format(new Date(), "dd-MM-yyyy HH:mm:ss"),
            note: remarkUpdate,
          }
        : {};

      if (doctorId === 0) {
        setDoctorId(null);
      }
      let updateData: any = {
        appointment_id: updatedUser.id,
        appointment_status: updatedUser.appointment_status,
        appointment_type: updatedUser.appointment_type,
        remark: remarkUpdateData,
        rating: rating ? parseInt(rating) : null,
        feedback: feedback ? feedback : null,
        doctor_id: doctorId === 0 ? null : parseInt(doctorId),
        video_consultation_allowed: isVideoConsultationAllowed,
      };

      if (
        selectedUser.appointment_type === "growth" ||
        selectedUser.appointment_type.toLowerCase().includes("lactation")
      ) {
        updateData.slot_id = updatedUser.slot_id;
      } else {
        updateData.scheduled_at = appointmentDate;
      }

      const jsonData = JSON.stringify(updateData);

      const config = {
        method: "post",
        url: process.env.REACT_APP_API_URL + "consultation/appointment/update/",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${getToken()}`,
        },
        data: jsonData,
      };

      const response = await axios(config);
      setRemarkUpdate("");
      setRating("");
      setFeedback("");
      setDoctorId(0);
      setShowModal(false);
      fetchData({
        mobileNumber,
        isFilterSelectedForUser,
        isFilterSelectedForStatus,
        filterChangeForUser,
        statusFilter,
        currentPage,
      });
    } catch (error) {
      console.error(error);
      toast.error("Failed to update appointment");
      toast.error("Contact Utkarsh");
    }
  };
  const FetchDoctorGrowthandLactation = async (category: string) => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}doctors/doctors/all/?category=${category}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getToken()}`,
          },
        }
      );
      setDoctorsData(data);
    } catch (error) {
      console.error("Error fetching doctors:", error);
      toast.error("Failed to fetch doctors");
    }
  };

  const fetchDoctorSlots = async (
    doctorId: any,
    slotType: any,
    mobileNumber?: any
  ) => {
    try {
      const phoneToUse = mobileNumber || selectedUser.phone_number;
   
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}doctors/get-doctor-appointment-slot/`,
        { doctor_id: doctorId, source: "support portal", slot_type: slotType, mobile:phoneToUse },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getToken()}`,
          },
        }
      );

      const slotData = data.appointments.map((slot: any) => ({
        value: slot.id,
        label: `${slot.date} (${dayjs(slot.time_from, "HH:mm").format(
          "hh:mm A"
        )} - ${dayjs(slot.time_to, "HH:mm").format("hh:mm A")})`,
      }));
      setSlots(slotData);
    } catch (error) {
      console.error("Error fetching doctor slots:", error);
      toast.error("Failed to fetch doctor slots");
    }
  };

  useEffect(() => {
    if (showModal && doctorId) {
      const phoneToUse = mobileNumber || selectedUser.phone_number;
      
      if (!phoneToUse) {
      } else {
        fetchDoctorSlots(doctorId, selectedUser.appointment_type);
      }
    }
    if (selectedUser.appointment_type === "growth") {
      FetchDoctorGrowthandLactation("growth");
    } else if (
      selectedUser.appointment_type.toLowerCase().includes("lactation")
    ) {
      FetchDoctorGrowthandLactation("lactation");
    }
  },[showModal, doctorId, mobileNumber, selectedUser.phone_number]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-clinic-900 opacity-75"></div>
      <div className="custom-scrollbar relative z-10 h-[95vh] w-[45%] overflow-y-auto rounded-lg border border-clinic-200 bg-white shadow-lg md:mx-auto">
        <div className="text-sm">
          <div className="p-2 md:p-8">
            <h2 className="text-center text-base font-bold text-clinic-900">Appointment Data</h2>
            <div className="mt-2 space-y-4 md:mt-4">
              <div className="relative space-y-4 rounded-md border border-clinic-200 p-2">
                <p className={`absolute -top-[8px] left-4 bg-white px-1 ${microLabel}`}>
                  User details
                </p>
                <div className="flex flex-col">
                  <p className="font-normal">
                    Phone Number:{" "}
                    <span className="font-medium text-clinic-700 tabular-nums">
                      {selectedUser.phone_number}
                    </span>
                  </p>
                </div>
                <div className="flex justify-between">
                  <p className="font-normal">
                    Appointment Created:{" "}
                    <span className="font-medium text-clinic-700 tabular-nums">
                      {format(
                        parseISO(selectedUser.created_at),
                        "dd-MM-yyyy HH:mm:ss"
                      )}
                    </span>
                  </p>
                  <p className="font-normal">
                    Appointment Updated: {"  "}
                    <span className="font-medium text-clinic-700 tabular-nums">
                      {format(
                        parseISO(selectedUser.updated_at),
                        "dd-MM-yyyy HH:mm:ss"
                      )}
                    </span>{" "}
                  </p>
                </div>
                <div className="flex flex-col">
                  <p className="font-normal">
                    Appointment Type:{" "}
                    <span className="font-medium text-clinic-700">
                      {appointmentType}
                    </span>
                  </p>
                </div>
                <div className="flex flex-col">
                  <p className="font-normal">
                    Subscription Name:{" "}
                    <span className="font-medium text-clinic-700">
                      {selectedUser.subscription_name}
                    </span>
                  </p>
                </div>
              </div>

              <div className="relative flex justify-between rounded-md border border-clinic-200 p-2 pt-4 gap-x-6">
                <p className={`absolute -top-[8px] left-4 bg-white px-1 ${microLabel}`}>
                  Doctor Details
                </p>

              <div className="flex flex-col w-full">
                <p className="font-normal">
                  Doctor's Name:<b className="text-xl text-crit-600">*</b>
                </p>
                <select
                  value={doctorId}
                  onChange={(e) => setDoctorId(e.target.value)}
                  className={selectCls}
                >
                  <option value={0}>Select a doctor</option>
                  {doctorsData.map((doctor, index) => (
                    <option key={index} value={doctor.id}>
                      {doctor.name}
                    </option>
                  ))}
                </select>
              </div>

              {(selectedUser.appointment_type === "growth" ||
                selectedUser.appointment_type
                  .toLowerCase()
                  .includes("lactation")) && (
                <div className="flex flex-col w-full">
                  <p className="font-normal">
                    Slots:<b className="text-xl text-crit-600">*</b>
                  </p>
                  <select
                    value={slotId}
                    onChange={(e) => setSlotId(e.target.value)}
                    className={selectCls}
                  >
                    <option value={0}>Select a slot</option>
                    {slots.length > 0 ? (
                      slots.map((slot, index) => (
                        <option key={index} value={slot.value}>
                          {slot.label}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        No slots available
                      </option>
                    )}
                  </select>
                </div>
              )}
              </div>


              <div className="relative flex flex-col justify-between rounded-md border border-clinic-200 p-2 pt-4">
                <p className={`absolute -top-[8px] left-4 bg-white px-1 ${microLabel}`}>
                  Appointment details
                </p>
                <div className="flex justify-between">
                <div className={`flex flex-col w-[50%] ${dateIsNull && ((appointmentStatus!=="created" && appointmentStatus!=="cancelled") || doctorId!=0) && 'border-2 px-3 py-2 bg-warn-50 border-warn-200 rounded-md flex justify-center items-left'}`}>
                  {dateIsNull && ((appointmentStatus!=="created" && appointmentStatus!=="cancelled") || doctorId!=0) && <p className="text-warn-600 pb-2 font-semibold">Please Select an Appointment Date</p>}    
                  <p className={"flex gap-1 font-normal"}>
                    Appointment Date:
                    <b className="text-xl text-crit-600">*</b>
                  </p>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      value={appointmentDate}
                      onChange={(date) => {
                        if(date){
                          setDateIsNull(false);
                        }else{
                          setDateIsNull(true);
                        }
                        setAppointmentDate(date);
                      }}
                      ampmInClock={false}
                      ampm={false}
                      format="DD-MM-YYYY HH:mm:ss"
                      disabled={
                        selectedUser.appointment_type === "growth" ||
                        selectedUser.appointment_type
                          .toLowerCase()
                          .includes("lactation")
                      }
                    />
                  </LocalizationProvider>
                </div>
                <div className="flex flex-col w-[40%]">
                  <p className="flex gap-1 font-normal">
                    Edit Status: <b className="text-xl text-crit-600">*</b>
                  </p>
                  <select
                    value={appointmentStatus}
                    onChange={handleAppointmentStatusChange}
                    className={selectCls}
                  >
                    {appointmentStatusSelectOptions.map((status, index) => (
                      <option key={index} value={status.value}>
                        {status.name}
                      </option>
                    ))}
                  </select>
                </div>
                </div>
                {selectedUser.preferred_time && <div className="mt-3 border-2 border-warn-200 bg-warn-50 rounded-md px-4 py-1">
                  <p className="font-bold text-warn-700 flex justify-between items-center">
                    <p className="tracking-wide">Preferred Appointment Time :</p>
                    <p className="text-lg tabular-nums">{selectedUser.preferred_time ? selectedUser.preferred_time : "N/A"}</p>
                  </p>
                </div>}
              </div>

              <div className="relative space-y-4 rounded-md border border-clinic-200 p-2">
                <p className={`absolute -top-[8px] left-4 bg-white px-1 ${microLabel}`}>
                  Remark
                </p>
                <div className="flex flex-col">
                  <p className="font-normal">Remark History:</p>
                  <p
                    className={`flex flex-col px-4 py-2 ${
                      selectedUser.remark.update &&
                      selectedUser.remark.update.length > 0
                        ? "rounded-md border"
                        : ""
                    }`}
                  >
                    {selectedUser.remark.update &&
                      selectedUser.remark.update.length > 0 &&
                      selectedUser.remark.update.map((userRemark: any, index: number) => {
                        return (
                          <span
                            key={index}
                            className="font-medium text-clinic-700"
                          >
                            {index + 1}. {userRemark.note}{" - by "}
                            <span className="text-clinic-500">
                              {userRemark.email_id.split(".")[0].split("@")[0]}
                            </span>{" "}
                            on <span className="text-clinic-500 tabular-nums">
                            {userRemark.time.split(" ")[0]}
                            </span>
                          </span>
                        );
                      })}
                  </p>
                </div>
                <div className="flex flex-col">
                  <p className="flex gap-1 font-normal">
                    Remark:
                    <b className="text-xl text-crit-600">*</b>
                  </p>
                  <input
                    value={remarkUpdate}
                    onChange={(e) => {
                      if (e.target.value.trim() !== "")
                        setRemarkUpdate(e.target.value);
                    }}
                    type="text"
                    className={inputCls}
                  />
                </div>
              </div>

              <div className="flex flex-col">
                <p className="flex gap-1 font-normal ">
                  Feedback: <b className="text-xl text-crit-600">*</b>
                </p>
                <textarea
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                  className={`resize-none ${inputCls}`}
                />
              </div>
              <div className="flex flex-row justify-between gap-4">
                <div className="flex w-full flex-col justify-around">
                  <p className="flex gap-1 font-normal ">
                    Video Consultation Allowed Via App:{" "}
                    <b className="text-xl text-crit-600">*</b>
                  </p>
                  <select
                    value={isVideoConsultationAllowed as any}
                    onChange={(e) => {
                      setIsVideoConsultationAllowed(
                        e.target.value === "true" ? true : false
                      );
                    }}
                    className={selectCls}
                  >
                    <option value={true as any}>True</option>
                    <option value={false as any}>False</option>
                  </select>
                </div>

                <div className="flex flex-col">
                  <p className="flex gap-1 font-normal ">
                    Rating: <b className="text-xl text-crit-600">*</b>
                  </p>
                  <select
                    value={rating}
                    onChange={(e) => {
                      setRating(e.target.value);
                    }}
                    className={selectCls}
                  >
                    <option value="null" disabled>
                      Select a Rating
                    </option>
                    <option value="1">Unsatisfied</option>
                    <option value="2">Satisfied</option>
                    <option value="3">Very Satisfied</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="sticky -bottom-1 flex justify-end space-x-4 border-t border-clinic-100 bg-white py-2 px-2 md:px-8">
            <button
              className={ghostBtn}
              onClick={handleCloseModal}
            >
              Cancel
            </button>
            <button
              className={primaryBtn}
              onClick={handleSaveClick}
              disabled={dateIsNull && ((appointmentStatus!=="created" && appointmentStatus!=="cancelled") || doctorId!=0)}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentModal;
